/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'billingRuleEdit.title', 'defaultMessage': 'Editing billing rules'}
});

interface BillingRuleEditProps {
    intl: IntlShape;
    user: User;
}

class BillingRuleEdit extends React.Component<BillingRuleEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'billingRules';

    constructor(props) {
        super(props);
    }

    render() {
        let data = this.props.user.organisation.billingRule;
        let type = types[this.typeName];


        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={{
                        'flowDef': {
                            values: this.props.user.flowDefs.edges.map(({node}) => node),
                            display: (item) => {
                                return item['name'];
                            },
                        },
                        'flow': {
                            values: this.props.user.organisation.flows.edges.map(({node}) => node),
                            display: (item) => {
                                return item['flowTitle'];
                            },
                        },
                        'billingNote': {},
                        'validSince': {},
                        'validTo': {},
                        'overridePricePerInstance': {},
                        'overridePricePerInstanceNext': {},
                        'overridePricePerInvocation': {},
                        'overrideTablePerInvocation': {},
                        'overrideMinPrice': {},
                    }}
                    data={data}
                    fatQuery={Relay.QL `fragment on UpdateBillingRulePayload {
                        updatedNode {
                            id,
                            billingNote,
                            validSince,
                            validTo,
                            overridePricePerInstance,
                            overridePricePerInstanceNext,
                            overridePricePerInvocation,
                            overrideTablePerInvocation,
                            overrideMinPrice,
                            flow_id,
                            flow {
                                id,
                                realId,
                                name,
                                flowTitle,
                            },
                            flowDef_id,
                            flowDef {
                                id,
                                name,
                            },
                            organisation_id,
                            organisation {
                                id
                            },
                        },
                    }`}
                    metadata={type}
                    mutation={Relay.QL `mutation { updateBillingRule }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(BillingRuleEdit), (props) => {
    return props.user.organisation && props.user.organisation.billingRule;
}), {
    initialVariables: {
        organisationId: '',
        billingRuleId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    billingRule(id: $billingRuleId) {
                        id,
                        billingNote,
                        validSince,
                        validTo,
                        flow_id,
                        flow {
                            id,
                            realId,
                            name,
                        },
                        overridePricePerInstance,
                        overridePricePerInstanceNext,
                        overridePricePerInvocation,
                        overrideTablePerInvocation,
                        overrideMinPrice,
                        flowDef_id,
                        flowDef {
                            id,
                            name
                        }
                    },
                    flows(first: 2000, deleted: false) {
                        edges {
                            node {
                                id,
                                realId,
                                flowTitle,
                                name,
                            }
                        }
                    }    
                },
                flowDefs(first: 2000) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                        }
                    }
                }
            }
        `,
    },
});
